import React, { Component, useEffect, useState } from 'react';
import { connect } from "react-redux";
import { debounce } from "lodash";

import axios from "axios";
import moment from "moment";
import Select from 'react-select';

import { useLazyQuery } from '@apollo/client';
import { GET_VEHICLE_BY_SOURCE_ID } from '../../../../GraphQL/Queries/vehicles.js';

import Navbar from '../../../EndUser/EU-Navbar.jsx';
import VehicleCell from "../../Stakeholder/Vehicle/VehicleCell";
import DatePicker from '../../../Common/DatePicker.jsx';
import { EUVehicleCard } from '../../../EndUser/EUVehicleCard';
import ModalRoutes from '../../ModalRoutes';

import { setVehicleDb } from '../../../../Actions/endUserActions';

import { LoadingIcon } from '../../../Common/Loading_Icon';

import { checkCredentials } from '../../../../Helpers/checkCredentials';
import { reverseReceiveTime } from '../../../../Helpers/ReceiveTimeInArray';
import { BackChevron } from '../../../Common/Buttons/Icons.js';
import Flags from '../../../Common/Flags.jsx';
import { Trans, Translation } from 'react-i18next';

import { EUBookingFormButtons } from './EUBookingFormButtons';
import EUVehicleSpecification from './EUVehicleSpecification.jsx';

const VehicleImage = ({ vehicle, settings, vehicle_details }) => {
    const [vehicleImage, setVehicleImage] = useState(settings.images.vehicle_placeholder);

    const [getVehicleQuery, { loading: loadingVehicle }] = useLazyQuery(GET_VEHICLE_BY_SOURCE_ID, {
        errorPolicy: 'all',
        fetchPolicy: 'network-only',
    });

    useEffect(() => {
        if (vehicle?.Photos) {
            const imageUrl = `https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/${vehicle.Photos}`;
            setVehicleImage(imageUrl);
        } else {
            getVehicleQuery({ variables: { sourceVehicleId: +vehicle.V_ID } })
                .then((vehicleResponse) => {
                    const gqlVehicle = vehicleResponse?.data.getVehicleBySourceVehicleId;

                    if (gqlVehicle?.photoUrl) {
                        setVehicleImage(gqlVehicle?.photoUrl);
                    }
                })
        }
    }, [vehicle])

    return (
        <div className="eu-vehicle--header-banner" style={{ backgroundImage: `url(${vehicleImage})`, height: '100%', position: 'relative' }}>
            <Flags vehicle={vehicle} vehicle_details={vehicle_details} />
            {vehicleImage && vehicleImage !== settings.images.vehicle_placeholder && (
                <div style={{ position: 'absolute', padding: '6px', bottom: 0, width: '100%', background: 'rgba(0,0,0,0.4)' }}>
                    <span style={{ marginLeft: "8px", color: "#FFF", fontSize: "12px" }}>*<Trans>The actual vehicle's colour and trim may differ from the image shown above</Trans></span>
                </div>
            )}
        </div>
    )
}

class EUVehicle extends Component {
    constructor(props) {
        super(props);

        this.toggleRequest = this.toggleRequest.bind(this);
        this.changeTime = this.changeTime.bind(this);
        this.changeTimeSelect = this.changeTimeSelect.bind(this);
        this.updateSelect = this.updateSelect.bind(this);
        this.updateField = this.updateField.bind(this);
        this.submitBooking = debounce(this.submitBooking.bind(this), 500);
        this.openSpecSheet = this.openSpecSheet.bind(this);
        this.selectStartDate = this.selectStartDate.bind(this);
        this.selectEndDate = this.selectEndDate.bind(this);
        this.imageError = this.imageError.bind(this);
        this.renderRightArrow = this.renderRightArrow.bind(this);
        this.renderLeftArrow = this.renderLeftArrow.bind(this);
        this.renderSimilarVehicles = this.renderSimilarVehicles.bind(this);
        this.navigateToVehicle = this.navigateToVehicle.bind(this);

        this.state = {
            unavailable_dates: [],
            pickup_times: [],
            dropoff_times: [],
            booking_form: {},
            request_book: false,
            selected_pickup: null,
            selected_dropoff: null,
            vehicle_details: {},
            vehicle_options: {},
            loading_vehicle: true,
            stakeholder: null,
            division: null,
            logo: null
        };
    }

    componentDidMount() {
        var self = this;

        if (! (this.props.match.params.v_id in this.props.endUser.vehicle_db)) {
            document.title = "Vehicle - FleetXPress"
            axios.get('/ajax/eu-vehicle/' + this.props.match.params.v_id)
            .then(function(response) {
                checkCredentials(response);

                self.props.dispatch(setVehicleDb([response?.data.vehicle], self.props.endUser.vehicle_db))
                document.title = response?.data.vehicle.Year + " " + response?.data.vehicle.Make + " " + response?.data.vehicle.Model + " " + response?.data.vehicle.Trim + " - FleetXPress"

                self.setState({
                    vehicle_details: response?.data.vehicle_details,
                    vehicle_options: response?.data.vehicle_options,
                    loading_vehicle: false,
                    stakeholder: response?.data.vehicle.stakeholder.Company.replace(/\s+/g, '').toLowerCase(),
                    division: response?.data.vehicle.stakeholder.Division.replace(/\s+/g, '').toLowerCase(),
                    logo: response?.data.logo
                })

                var stakeholder = response?.data.vehicle.stakeholder.Company.replace(/\s+/g, '').toLowerCase()
                var division = response?.data.vehicle.stakeholder.Division.replace(/\s+/g, '').toLowerCase()
                
                axios.post('/ajax/eu-home/update', {
                    stakeholder: stakeholder,
                    division: division
                }).then(function(response) {
                    self.props.dispatch(setVehicleDb(response?.data.vehicles, self.props.endUser.vehicle_db))
                }).catch(function(error) {
                    if(error.response?.status == 401){
                        showStatusMsg(error.response?.data.error);
                    } else if(error.response?.status == 422) {
                        var error_message = "";
        
                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });
        
                        showStatusMsg(error_message);

                    if (error.response?.data.message === "Incorrect Privileges.") {
                        self.props.history.push('/')
                    }
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);

                    if (error.response?.data.message === "Incorrect Privileges.") {
                        self.props.history.push('/')
                    }
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        } else {
            document.title = this.props.endUser.vehicle_db[this.props.match.params.v_id].Year + " " + this.props.endUser.vehicle_db[this.props.match.params.v_id].Make + " " + this.props.endUser.vehicle_db[this.props.match.params.v_id].Model + " " + this.props.endUser.vehicle_db[this.props.match.params.v_id].Trim + " - FleetXPress"
            
            var stakeholder = this.props.endUser.vehicle_db[this.props.match.params.v_id].stakeholder.Company.replace(/\s+/g, '').toLowerCase()
            var division = this.props.endUser.vehicle_db[this.props.match.params.v_id].stakeholder.Division.replace(/\s+/g, '').toLowerCase()

            axios.get('/ajax/eu-vehicle/' + this.props.match.params.v_id)
            .then(function(response) {
                checkCredentials(response);
                self.setState({
                    vehicle_details: response?.data.vehicle_details,
                    vehicle_options: response?.data.vehicle_options,
                    loading_vehicle: false,
                    stakeholder: response?.data.vehicle.stakeholder.Company.replace(/\s+/g, '').toLowerCase(),
                    division: response?.data.vehicle.stakeholder.Division.replace(/\s+/g, '').toLowerCase(),
                    logo: response?.data.logo
                })

                axios.post('/ajax/eu-home/update', {
                    stakeholder: stakeholder,
                    division: division
                }).then(function(response) {
                    self.props.dispatch(setVehicleDb(response?.data.vehicles, self.props.endUser.vehicle_db))
                }).catch(function(error) {
                    if(error.response?.status == 401){
                        showStatusMsg(error.response?.data.error);
                    } else if(error.response?.status == 422) {
                        var error_message = "";
        
                        $.each(error.response?.data.errors, function (index, element) {
                            error_message += element + '<br />';
                        });
        
                        showStatusMsg(error_message);
                    } else {
                        showStatusMsg("Requested information not found");
                    }
                })
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        }

        axios.post('/ajax/vehicle/' + this.props.match.params.v_id + "/unavailable_dates")
        .then(function(response) {
            checkCredentials(response);
            self.setState({
                unavailable_dates: response?.data
            })
        })
    }

    
    openSpecSheet() {
        var win = window.open(this.props.endUser.vehicle_db[this.props.match.params.v_id].Catalogue_Link);
        win.focus();
    }

    toggleRequest() {
        var booking_form = this.state.booking_form

        booking_form['vehicle_usage'] = 1

        this.setState({
            request_book: !this.state.request_book,
            booking_form: booking_form
        })
    }

    changeTime(e) {
        var booking_form = this.state.booking_form
        var timing = e.target.value
        var name = e.target.name
        var label = reverseReceiveTime(timing)
        var self = this;

        booking_form[name] = timing;
        
        
        if (name === "pick_up_time") {
            var selected_pickup = {value: timing, label: label, name: name};
            this.setState({
                selected_pickup: selected_pickup
            })

        } else if (name === "drop_off_time") {
            var selected_dropoff = {value: timing, label: label, name: name};
            this.setState({
                selected_dropoff: selected_dropoff
            })
        }

        self.setState({
            booking_form: booking_form
        })
    }

    changeTimeSelect(option) {
        var booking_form = this.state.booking_form
        var timing = option.value
        var name = option.name
        var self = this;

        booking_form[name] = timing;
        
        if (name === "pick_up_time") {
            this.state.selected_pickup = option;
        } else if (name === "drop_off_time") {
            this.state.selected_dropoff = option;
        }

        self.setState({
            booking_form: booking_form
        })
    }

    updateSelect(optionSelected) {
        var name = optionSelected.name
        var value = optionSelected.value

        var booking_form = this.state.booking_form
        booking_form[name] = value

        this.setState({
            booking_form: booking_form
        })
    }

    updateField(event) {
        var name = event.target.name
        var value = event.target.value

        var booking_form = this.state.booking_form
        booking_form[name] = value
        
        this.setState({
            booking_form: booking_form
        })
    }

    selectStartDate(event) {
        var booking_form = this.state.booking_form
        booking_form["start_date"] = event.target.value
        
        this.setState({
            booking_form: booking_form
        })

        this.loadPickupTimes(event.target.value);
    }

    selectEndDate(event) {
        var booking_form = this.state.booking_form
        booking_form["end_date"] = event.target.value
        
        this.setState({
            booking_form: booking_form
        })

        this.loadDropoffTimes(event.target.value);
    }

    loadPickupTimes(date) {
        var self = this;

        axios.post('/ajax/vehicle/' + self.props.match.params.v_id + "/options", {
            'date': date,
            'type': 'pickup'
        })
        .then(function(response) {
            var selected_pickup = {value: response?.data[0].value, label: response?.data[0].option, name: "pick_up_time"};
            var booking_form = self.state.booking_form
            booking_form['pick_up_time'] = response?.data[0].value

            self.setState({
                pickup_times: response?.data,
                selected_pickup: selected_pickup,
                booking_form: booking_form
            })
        })
    }

    loadDropoffTimes(date) {
        var self = this;
        axios.post('/ajax/vehicle/' + self.props.match.params.v_id + "/options", {
            'date': date,
            'type': 'dropoff'
        })
        .then(function(response) {
            var selected_dropoff = {value: response?.data[0].value, label: response?.data[0].option, name: "drop_off_time"};
            var booking_form = self.state.booking_form
            booking_form['drop_off_time'] = response?.data[0].value

            self.setState({
                dropoff_times: response?.data,
                selected_dropoff: selected_dropoff
            })
        })
    }

    submitBooking(createBookingGraphQL, setLoading) {
        var self = this;

        const bookingBody = {
            vehicle_id: self.props.match.params.v_id,
            start_date: moment(self.state.booking_form.start_date).format("YYYY-MM-DD"),
            end_date: moment(self.state.booking_form.end_date).format("YYYY-MM-DD"),
            pick_up_time: self.state.booking_form.pick_up_time,
            drop_off_time: self.state.booking_form.drop_off_time,
            booking_type: 4,
            vehicle_usage: self.state.booking_form.vehicle_usage,
            notes: self.state.booking_form.notes,
            user: self.props.userSession.user.profile_id,
            pick_up_person: self.props.userSession.user.full_name
        }

        axios.post('/ajax/booking', bookingBody)
            .then(function(response) {
                // self.setState({ request_book: false })

                // [not in use due to queue data sync implementation]
                // createBookingGraphQL(bookingBody, response?.data?.booking)

                self.props.history.push("/bookings/pending")
                showStatusMsg(response?.data.message, 'success')
            })
            .catch(function(error) {
                setLoading(false)
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Error creating booking. Please try again later.");
                }
            })
    }

    imageError(e) {
        e.target.src = this.props.settings.images.vehicle_placeholder_square.includes("images/") ? this.props.settings.images.vehicle_placeholder_square : "images/" + this.props.settings.images.vehicle_placeholder_square
    }

    navigateToVehicle(vehicle_id) {
        this.setState({
            unavailable_dates: [],
            pickup_times: [],
            dropoff_times: [],
            booking_form: {}
        })

        var self = this;

        axios.post('/ajax/vehicle/' + vehicle_id + "/unavailable_dates")
        .then(function(response) {
            self.setState({
                unavailable_dates: response?.data
            })
        })

        this.props.history.push("/vehicle/" + vehicle_id)
    }

    renderRightArrow() {
        var next;
        var current_index;
        for (var i = 0; i < this.props.endUser.vehicles.length; i++) {
            if (this.props.endUser.vehicles[i].V_ID === parseInt(this.props.match.params.v_id)) {
                current_index = i;
            }
        }

        if (current_index + 1 < this.props.endUser.vehicles.length) {
            next = <i className="fas fa-arrow-right" data-tip = 'Next Vehicle' onClick={() => this.navigateToVehicle(this.props.endUser.vehicles[current_index + 1].V_ID)}></i>
        } else {
            next = <i className="fas fa-arrow-right disabled" data-tip = 'Next Vehicle'></i>
        }
        
        return next;
    }

    renderLeftArrow() {
        var previous;
        var current_index;
        for (var i = 0; i < this.props.endUser.vehicles.length; i++) {
            if (this.props.endUser.vehicles[i].V_ID === parseInt(this.props.match.params.v_id)) {
                current_index = i;
            }
        }

        if (this.props.endUser.vehicles.length > 1 && current_index !== 0) {
            previous = <i className="fas fa-arrow-left mr-16" data-tip = 'Previous Vehicle' onClick={() => this.navigateToVehicle(this.props.endUser.vehicles[current_index - 1].V_ID)}></i>
        } else {
            previous = <i className="fas fa-arrow-left mr-16 disabled" data-tip = 'Previous Vehicle'></i>
        }
        
        return previous;
    }

    renderSimilarVehicles() {
        var similar_vehicles = [];
        var similarity_score = {};

        let current_vehicle = this.props.endUser.vehicle_db[this.props.match.params.v_id]
        for (var i = 0; i < this.props.endUser.vehicles.length; i++) {
            var score = 0;
            //Score is given 20 if same Model
            if (this.props.endUser.vehicles[i].Model === current_vehicle.Model) {
                score += 20
            }

            //Same trim is 10 points
            if (this.props.endUser.vehicles[i].Trim === current_vehicle.Trim) {
                score += 10
            }

            //Same year is 10 points
            if (this.props.endUser.vehicles[i].Year === current_vehicle.Year) {
                score += 10
            }

            //Same body style is 10
            if (this.props.endUser.vehicles[i].Body_Style === current_vehicle.Body_Style) {
                score += 10
            }

            //Same engine is 10
            if (this.props.endUser.vehicles[i].Engine === current_vehicle.Engine) {
                score += 10
            }

            //Same transmission is 10
            if (this.props.endUser.vehicles[i].Transmission === current_vehicle.Transmission) {
                score += 10
            }

            //Same Drive train is 10
            if (this.props.endUser.vehicles[i].Drive_Train === current_vehicle.Drive_Train) {
                score += 10
            }

            //Same Tires is 5
            if (this.props.endUser.vehicles[i].Tires === current_vehicle.Tires) {
                score += 5
            }

            //Same Roof is 5
            if (this.props.endUser.vehicles[i].Roof === current_vehicle.Roof) {
                score += 5
            }

            //Same exterior exact color is 5
            if (this.props.endUser.vehicles[i].Exterior_Exact_Color === current_vehicle.Exterior_Exact_Color) {
                score += 5
            }

            //Same interior exact color is 5 
            if (this.props.endUser.vehicles[i].Interior_Exact_Color === current_vehicle.Interior_Exact_Color) {
                score += 5
            }

            similarity_score[this.props.endUser.vehicles[i].V_ID] = score
        }

        var items = Object.keys(similarity_score).map(function(key) {
            return [key, similarity_score[key]];
        });
          
        items.sort(function(first, second) {
            return second[1] - first[1];
        });

        for (var i = 0; i < items.length; i++) {
            var vehicle_id  = parseInt(items[i][0])
            if (vehicle_id !== current_vehicle.V_ID && similar_vehicles.length < 3) {
                similar_vehicles.push(<EUVehicleCard key={"vehicle_card_" + this.props.endUser.vehicle_db[vehicle_id].V_ID} vehicle={this.props.endUser.vehicle_db[vehicle_id]} settings={this.props.settings} />)
            }
        }

        if (similar_vehicles.length > 1) {
            return (
                <div className="eu-vehicle--wrapper eu-vehicle--similarvehicles">
                    <h3><Trans>Similar Vehicles</Trans></h3>
                    <div className="eu-vehicle--similarvehicles-wrapper">
                        {similar_vehicles}
                    </div>
                </div>
            )
        } else {
            return <div />
        }

    }

    render() {
        let vehicle = this.props.endUser.vehicle_db[this.props.match.params.v_id]
        let vehicle_details = this.state.loading_vehicle ? this.props.settings.vehicle_details : this.state.vehicle_details;
        let vehicle_options = this.state.loading_vehicle ? this.props.settings.vehicle_options : this.state.vehicle_options;

        return (
            <div>
                <Navbar history={this.props.history} match={this.props.match} location={this.props.location} />
                {
                    this.props.match.params.v_id in this.props.endUser.vehicle_db ?
                        <div className="container flex eu-container">
                            <div className="eu-vehicle--title">
                                <div className="eu-vehicle--wrapper">
                                    {this.state.division && this.state.stakeholder && (
                                        <Translation>
                                            {(t) => (

                                                <div className="eu-vehicle-logo" onClick={() => this.props.history.push("/vehicles/" + this.state.stakeholder + "/" + this.state.division)} data-tip={t("Back to Fleet")} >
                                                    {BackChevron()}
                                                    {this.state.logo && (
                                                        <img src={this.state.logo} />
                                                    )}
                                                </div>
                                            )}
                                            {/* <ReactTooltip effect="solid" place = "bottom"/> */}
                                        </Translation>
                                    )}
                                    <div className="eu-vehicle--title-left truncate" data-tip={vehicle.Year + " " + vehicle.Make + " " + vehicle.Model + " " + vehicle.Trim}>
                                        <h1>{vehicle.Year} {vehicle.Make} {vehicle.Model} {vehicle.Trim}</h1>
                                    </div>
                                    <div className="eu-vehicle--title-right">
                                        {this.renderLeftArrow()}
                                        {/* <ReactTooltip effect="solid" place = "bottom"/> */}
                                        {this.renderRightArrow()}
                                        {/* <ReactTooltip effect="solid" place = "bottom"/> */}
                                    </div>
                                </div>
                            </div>
                            <div className="eu-vehicle--maincontainer">
                                <div className="eu-vehicle--header">
                                    <VehicleImage vehicle={vehicle} settings={this.props.settings} vehicle_details={vehicle_details} />

                                    <EUVehicleSpecification
                                        vehicle={vehicle}
                                        vehicle_details={vehicle_details}
                                        vehicle_options={vehicle_options}
                                        isLoading={this.state.loading_vehicle}
                                        sourceVehicleId={this.props.match.params.v_id}
                                        {...this.props}
                                    />
                                </div>
                                <div className="eu-vehicle--midsection">
                                    <div className="eu-vehicle--wrapper">
                                        <div className="eu-vehicle--text">
                                            <div className = "eu-vehicle--text-section">
                                                <h4><Trans>Description</Trans></h4>
                                                <p>{vehicle.Description}</p>
                                            </div>  
                                            {
                                                vehicle.Accessories ?
                                                    <div className = "eu-vehicle--text-section">
                                                        <h4><Trans>Accessories & Modifications</Trans></h4>
                                                        <p>{vehicle.Accessories}</p>
                                                    </div>
                                                :
                                                    null
                                            }      
                                            
                                        </div>
                                        <div className="eu-vehicle--booking">
                                            <div className="eu-vehicle--booking-wrapper">
                                                <div className="eu-vehicle--booking-pickup">
                                                    <h5><Trans>Pick Up</Trans></h5>
                                                    <Translation>
                                                    {
                                                        (t) => <DatePicker id="eu_booking_start_date" name="eu_booking_start_date" placeholder={t("Choose Date")} vehicle_id={this.props.match.params.v_id} value={this.state.booking_form.start_date ? this.state.booking_form.start_date : ""} updateValue={this.selectStartDate} />
                                                    }
                                                        
                                                    </Translation>

                                                    <select name="pick_up_time" id="" disabled={! this.state.booking_form.start_date} onChange={this.changeTime}>
                                                        {
                                                            ! this.state.booking_form.start_date ?
                                                                <option>9:00 AM</option>
                                                            :
                                                                this.state.pickup_times.map((time) => {
                                                                    return(
                                                                        <option value={time.value}>{time.option}</option>
                                                                    )
                                                                })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="eu-vehicle--booking-arrow">
                                                    <i className="fas fa-arrow-right"></i>
                                                </div>
                                                <div className="eu-vehicle--booking-dropoff">
                                                    <h5><Trans>Drop Off</Trans></h5>
                                                    <Translation>
                                                    {
                                                        (t) => <DatePicker id="eu_booking_end_date" name="eu_booking_end_date" placeholder={t("Choose Date")} vehicle_id={this.props.match.params.v_id} 
                                                        disabled={this.state.booking_form.pick_up_time === null} value={this.state.booking_form.end_date ? this.state.booking_form.end_date : ""} updateValue={this.selectEndDate} 
                                                            start_date_id="eu_booking_start_date" 
                                                                key={"eu_booking_end_date_" + this.state.booking_form.start_date + "_" + this.state.booking_form.end_date} />
                                                    }
                                                    </Translation>
                                                    <select name="drop_off_time" id="" disabled={! this.state.booking_form.end_date} onChange={this.changeTime}>
                                                    {
                                                            ! this.state.booking_form.end_date?
                                                                <option>5:00 PM</option>
                                                            :
                                                                this.state.dropoff_times.map((time) => {
                                                                    return(
                                                                        <option value={time.value}>{time.option}</option>
                                                                    )
                                                                })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            <button className = "button primary" onClick={this.toggleRequest}><Trans>Book Now</Trans></button>
                                        </div>
                                    </div>
                                    {this.renderSimilarVehicles()}
                                    <div className="eu-vehicle--booking-mobile">
                                        <button className = "button primary" onClick={this.toggleRequest}><Trans>Book Now</Trans></button>
                                    </div>
                                </div>
                            </div>
                            {
                                this.state.request_book ? 
                                    <div className="booking_pullout_user">
                                        <div className="booking_header border-bottom">
                                            <div className = "card-header-title no-margin float-left"><Trans>Create Booking</Trans></div>
                                            <button onClick={this.toggleRequest} type='button' style={{cursor: "pointer"}} className = "float-right">
                                                <span aria-hidden='true' style={{fontSize: "1.8em", lineHeight: 1, display: "block"}}>&times;</span>
                                            </button>
                                            <div className = "clearfix"></div>
                                        </div>
                                        <div className="card-section">
                                            <div className = "row mb-24">
                                                <h4><Trans>Vehicle</Trans></h4>
                                                <VehicleCell history={this.props.history} match={this.props.match} location={this.props.location} vehicle={this.props.endUser.vehicle_db[this.props.match.params.v_id]} showImage noOverlay noTooltip/>
                                            </div>
                                            <div className = "row">
                                                <h4 className="mb-8"><Trans>Dates & Times</Trans></h4>
                                                <div className = "datetime-field">
                                                    <div className = "body medium"><Trans>Pick Up</Trans></div>
                                                    <Translation>
                                                    {
                                                        (t) =>  <DatePicker id="booking_start_date" classname="date-input-field datetime-date datepicker-start no-weekends" 
                                                        name="booking_start_date" placeholder={t("Choose Date")} disabled={false} vehicle_id={this.props.match.params.v_id} 
                                                            value={this.state.booking_form.start_date ? this.state.booking_form.start_date : ""} updateValue={this.selectStartDate} />
                                                    }
                                                    </Translation>
                                                   
                                                    <div className = "datetime-time">
                                                        <Select 
                                                            className="react_select_dropdown"
                                                            classNamePrefix="react_select"
                                                            defaultValue={this.state.selected_pickup}
                                                            options={
                                                                    this.state.pickup_times.map((time) => {
                                                                        return(
                                                                            {value: time.value, label: time.option, name: "pick_up_time"}
                                                                        )
                                                                    })
                                                            }
                                                            onChange={this.changeTimeSelect}
                                                        />
                                                    </div>
                                                    <div className = "clearfix"></div>
                                                </div>
                                            </div>
                                            <div className = "row">
                                                <div className = "datetime-field">
                                                    <div className = "body medium"><Trans>Drop Off</Trans></div>
                                                    <Translation>
                                                    {
                                                        (t) => <DatePicker id="booking_end_date" classname="date-input-field datetime-date datepicker-end no-weekends" 
                                                        name="booking_end_date" placeholder={t("Choose Date")} vehicle_id={this.props.match.params.v_id} 
                                                            value={this.state.booking_form.end_date ? this.state.booking_form.end_date : ""} updateValue={this.selectEndDate} 
                                                                disabled={this.state.booking_form.start_date ? "" : "disabled"} start_date_id="booking_start_date" 
                                                                    key={"booking_end_date_" + this.state.booking_form.start_date + "_" + this.state.booking_form.end_date} />
                                                    }
                                                    </Translation>
                                                    <div className = "datetime-time">
                                                        <Select 
                                                            className="react_select_dropdown"
                                                            classNamePrefix="react_select"
                                                            defaultValue={this.state.selected_dropoff}
                                                            options={
                                                                    this.state.pickup_times.map((time) => {
                                                                        return(
                                                                            {value: time.value, label: time.option, name: "drop_off_time"}
                                                                        )
                                                                    })
                                                            }
                                                            onChange={this.changeTimeSelect} />
                                                    </div>
                                                    <div className = "clearfix"></div>
                                                </div>
                                            </div>
                                            <div className = "row collapse">
                                                <h4 className="mb-8"><Trans>Booking Information</Trans></h4>
                                                <div className = "columns large-12 medium-12 small-12">
                                                    <label><Trans>Vehicle Usage</Trans>
                                                        <Select 
                                                            className="react_select_dropdown"
                                                            classNamePrefix="react_select"
                                                            value={{
                                                                value: this.state.booking_form.vehicle_usage,
                                                                label: this.props.settings.vehicle_usage_types[this.state.booking_form.vehicle_usage]
                                                            }}
                                                            options={
                                                                Object.keys(this.props.settings.vehicle_usage_types).map((key) => {
                                                                    return(
                                                                        {value: key, label: this.props.settings.vehicle_usage_types[key], name: "vehicle_usage"}
                                                                    )
                                                                })
                                                            }
                                                            onChange={this.updateSelect} />
                                                    </label>
                                                </div>
                                                <div className = "columns large-12 medium-12 small-12">
                                                    <label><Trans>Booking Notes</Trans>
                                                        <textarea name="notes" onChange={this.updateField}/>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <EUBookingFormButtons
                                            toggleRequest={this.toggleRequest}
                                            legacyApiCreateBooking={this.submitBooking}
                                            settings={this.props.settings}
                                            userSession={this.props.userSession}
                                            history={this.props.history}
                                        />

                                    </div>
                                :
                                    null
                            }
                        </div>
                    :
                        <LoadingIcon />
                }
                <ModalRoutes match={this.props.match} history={this.props.history} location={this.props.location}/>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    endUser: store.endUser,
    settings: store.settings,
    data: store.data
})

export default connect(mapStateToProps)(EUVehicle)